const componentStyles = (theme) => ({
  listItem: {
    border: "1px solid #e9ecef",
    borderWidth: "0 0 1px",
    "&:last-child": {
      borderBottomWidth: 0,
    },
  },

  listRoot: {
    // marginTop: "2rem",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    paddingBottom: "1.5rem",
    height: "100%",
  },
  listItemRoot: {
    // display: "flex",
    // fontSize: ".9rem",
    color: theme.palette.sidebarLinks.main,
    "&:hover": {
      color: theme.palette.sidebarLinks.dark,
    },
    "&:not(:last-child)": {
      borderBottom: "1px solid #e9ecef"
    }
  },
  buttonDelete: {
    color: theme.palette.white.main,
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
      borderColor: theme.palette.error.dark,
    },
  },
  iconButtonRoot: {
    color: theme.palette.error.main,
  },
  DeleteNotesListWrap: {
    margin: 0,
    padding: 0,
  },
  DeleteNotesListIcon: {
    minWidth: 25,
  },
});

export default componentStyles;